module.exports = __webpack_public_path__ + "assets/img/app_list.53c43640.png";